const APP_VERSION = '1781544743316';
export default APP_VERSION;
